import {
  IPackageMethod,
  ITabGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData
} from "@/app/interfaces/ITopup"
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react"
import { PackageAndMethod } from "./PackageAndMethod"
import { TopupOrderInfo } from "./TopupOrderInfo"
import { TopupOrderInfoMobile } from "./TopupOrderInfoMobile"
import { UpdatePhoneModal } from "./UpdatePhoneModal"

interface SecondStepProps {
  packageAndTab: ITopupPackage
  selectedTab: ITabGame | undefined
  handleChangeSelectedTab: (tab: ITabGame) => void
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
  extendData?: {
    alreadyGoldGift: number
    totalLimit: number
  } | null
  listPackageType: "image" | "text"
  gameDetail: ITopupGameDetail
}

export const SecondStep: FC<SecondStepProps> = ({
  packageAndTab,
  selectedTab,
  handleChangeSelectedTab,
  selectedData,
  setSelectedData,
  loading,
  setLoading,
  extendData,
  listPackageType,
  gameDetail
}) => {
  const [renderMethods, setRenderMethods] = useState<IPackageMethod[]>([])
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const layoutDiv = document.getElementById("layout")
    if (layoutDiv) layoutDiv.style.overflow = "initial"
  }, [])

  return (
    <div className="relative max-w-[1280px] w-full mx-auto md:mt-[64px] flex gap-[40px] lg:gap-[80px] flex-col lg:flex-row overflow-initial">
      <div className="flex-1">
        <PackageAndMethod
          packageAndTab={packageAndTab}
          selectedTab={selectedTab}
          handleChangeSelectedTab={handleChangeSelectedTab}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          setLoading={setLoading}
          loading={loading}
          renderMethods={renderMethods}
          setRenderMethods={setRenderMethods}
          extendData={extendData}
          listPackageType={listPackageType}
          gameDetail={gameDetail}
        />
      </div>
      <div className="lg:max-w-[463px] w-full hidden md:block lg:sticky lg:top-[95px] h-fit right-0">
        <TopupOrderInfo
          selectedData={selectedData}
          loadingCallingMethod={loading}
          setVisible={setVisible}
        />
      </div>

      <div className="block md:hidden">
        <TopupOrderInfoMobile
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          loadingCallingMethod={loading}
          renderMethods={renderMethods}
          setVisible={setVisible}
        />
      </div>

      {visible && (
        <UpdatePhoneModal visible={visible} setVisible={setVisible} />
      )}
    </div>
  )
}
